export const PARAM_IS_MINI_APP = 'isMiniApp'
export const PARAM_PHONE_NUMBER = 'phoneNumber'

export const PARAM_IS_EMBEDDED_VIEW = 'isEmbeddedView'
export const PARAM_APIKEY = 'apikey'
export const PARAM_SHOW_PHONE_INPUT = 'showPhoneInput'
export const PARAM_PAYMENT_METHOD = 'paymentMethod'
export const PARAM_HIDE_PAYMENT_METHOD = 'hidePaymentMethod'
export const PARAM_USERNAME_PREFIX = 'usernamePrefix'
export const PARAM_BACK_TO_HOME_MINI_APP_URL = 'backToHomeMiniAppUrl'
